import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=e35906d0&scoped=true&"
import script from "./ProductDescription.vue?vue&type=script&lang=js&"
export * from "./ProductDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=e35906d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35906d0",
  null
  
)

export default component.exports